export const Divider = () => (
  <div className="border-t-[0.5px] border-neutralColor5" />
)
